<script setup>

import HeaderComponent from "@/components/base/header-component.vue";
import FooterComponent from "@/components/base/footer-component.vue";
</script>

<template>
  <div class="app">
    <header-component />
    <RouterView />
    <footer-component />
  </div>
</template>

<style scoped lang="scss">
.app{
  background-color: #F8F5F3;
}
</style>
